import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserUpdateMenuItem from "@/v2-backoffice-client/user/update/UserUpdateMenuItem"
import UserResetPasswordMenuItem from "@/v2-backoffice-client/user/resetPassword/UserResetPasswordMenuItem"
import UserResetMfaMenuItem from "@/v2-backoffice-client/user/resetMfa/UserResetMfaMenuItem"
import UserRevokeSessionsMenuItem from "@/v2-backoffice-client/user/revokeSessions/UserRevokeSessionsMenuItem"
import UserExternalToolMenuItems from "@/v2-backoffice-client/user/UserExternalToolMenuItems"
import UserStatusUpdateActions from "@/v2-backoffice-client/user/status/update/UserStatusUpdateActions"
import UserTenantManageMenuItem from "@/v2-backoffice-client/user/tenant/manage/UserTenantManageMenuItem"

export type UserTableRowToolbarProps = {
  user: UserFragment
}

function UserTableRowToolbar(props: UserTableRowToolbarProps) {
  const { user } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <UserExternalToolMenuItems user={user} />

        <ActionMenu.Separator />

        <UserUpdateMenuItem user={user} />
        <UserTenantManageMenuItem user={user} />
        <UserResetPasswordMenuItem userId={user.Id} />
        <UserResetMfaMenuItem userId={user.Id} />

        <ActionMenu.Separator />

        <UserRevokeSessionsMenuItem userId={user.Id} />
        <UserStatusUpdateActions
          userId={user.Id}
          currentStatusCode={user.UserStatusCode}
        />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default UserTableRowToolbar
